import React, { useState } from 'react';
import HeaderConnection from '../Headers/HeaderConnection';

/**
 * HeaderConnectionShowcase - Demonstrates the HeaderConnection component
 */
const HeaderConnectionShowcase = () => {
  const [editableName, setEditableName] = useState('John Smith');
  
  const handleBackClick = () => {
    alert('Back button clicked!');
  };

  const showcaseStyle = {
    marginBottom: '20px'
  };
  
  // Example variants
  const headerExamples = [
    {
      title: 'Basic Header with Name Only',
      props: {
        name: 'Mark Mangan',
        showBackButton: true,
        onBackClick: handleBackClick,
        isTestMode: true
      }
    },
    {
      title: 'Header with Editable Name',
      props: {
        name: editableName,
        onNameChange: (e) => setEditableName(e.target.value),
        isEditable: true,
        showBackButton: true,
        onBackClick: handleBackClick,
        isTestMode: true
      }
    },
    {
      title: 'Header with Phone Contact',
      props: {
        name: 'Jane Doe',
        showBackButton: true,
        onBackClick: handleBackClick,
        contactInfo: { phone: '123-456-7890' },
        isTestMode: true
      }
    },
    {
      title: 'Header with All Contact Types',
      props: {
        name: 'Alex Johnson',
        showBackButton: true,
        onBackClick: handleBackClick,
        contactInfo: {
          phone: '123-456-7890',
          email: 'alex@example.com',
          instagram: 'alexj'
        },
        isTestMode: true
      }
    },
    {
      title: 'Header with Long Name',
      props: {
        name: 'Christopher Alexander Bartholomew Williamson III',
        showBackButton: true,
        onBackClick: handleBackClick,
        contactInfo: { email: 'christopher@example.com' },
        isTestMode: true
      }
    },
    {
      title: 'Header without Back Button',
      props: {
        name: 'James Wilson',
        showBackButton: false,
        contactInfo: { instagram: 'noback' },
        isTestMode: true
      }
    }
  ];

  return (
    <div>
      {headerExamples.map((example, index) => (
        <div key={index} style={showcaseStyle}>
          <h3>{`${index + 1}. ${example.title}`}</h3>
          <HeaderConnection {...example.props} />
        </div>
      ))}
    </div>
  );
};

export default HeaderConnectionShowcase;
